import { render, staticRenderFns } from "./modal_criar_horario.vue?vue&type=template&id=e67288da&scoped=true"
import script from "./modal_criar_horario.vue?vue&type=script&lang=js"
export * from "./modal_criar_horario.vue?vue&type=script&lang=js"
import style0 from "./modal_criar_horario.vue?vue&type=style&index=0&id=e67288da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67288da",
  null
  
)

export default component.exports